import { InnerNavigatorOption } from 'components/ui/InnerNavigator';
import { usePermissions } from 'hooks';

export function InnerOptions() {
  const { checkUserPermission } = usePermissions();
  const options: InnerNavigatorOption[] = [
    {
      title: 'Motoristas',
      route: '/settings/hub-drivers',
      hasPermission: checkUserPermission('accessConfigurator'),
    },
    {
      title: 'Novo Motorista',
      route: '/settings/hub-drivers/new',
      hasPermission: checkUserPermission('accessConfigurator'),
    },
  ];

  return { options };
}
